"use strict";

module.exports = require("./is-implemented")() ? Object.setPrototypeOf : require("./shim");



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/es5-ext/object/set-prototype-of/index.js
// module id = ../../../node_modules/es5-ext/object/set-prototype-of/index.js
// module chunks = 1